import { render, staticRenderFns } from "./Abeoffice.vue?vue&type=template&id=2d1b8520&scoped=true"
import script from "./Abeoffice.vue?vue&type=script&lang=js"
export * from "./Abeoffice.vue?vue&type=script&lang=js"
import style0 from "./Abeoffice.vue?vue&type=style&index=0&id=2d1b8520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b8520",
  null
  
)

export default component.exports